import { render, staticRenderFns } from "./framework-container.vue?vue&type=template&id=1f0f725e&"
import script from "./framework-container.vue?vue&type=script&lang=js&"
export * from "./framework-container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports